module.exports = __webpack_public_path__ + "img/heart.570cba07.svg";